import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { skipToken } from "@reduxjs/toolkit/query";

import { useSurveyPermissions } from "@/features/survey/hooks/useSurveyPermissions";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { useGetSurveyByIdQuery } from "@/redux/service";
import { useOrganizationId } from "@/shared/hooks/useOrganizationId";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import GuidancePage from "@/features/survey/guidance";

const GuidancePageRoute = () => {
  const { surveyId } = useParams();
  const currentOrganizationId = useOrganizationId();
  const { data: survey, isError } = useGetSurveyByIdQuery(
    surveyId && currentOrganizationId != null
      ? {
          surveyId,
          filters: { organization: currentOrganizationId },
        }
      : skipToken,
  );
  const currentUser = useSelector(selectCurrentUser);
  const { canView, isLoading: isLoadingPermissions } = useSurveyPermissions(
    survey,
    currentUser,
  );

  if (!survey || isLoadingPermissions || !currentUser) {
    return (
      <div className="flex justify-center full-width">
        <BaseSpinner />
      </div>
    );
  }

  if (isError || !canView) {
    return <Navigate to="/" />;
  }

  return <GuidancePage survey={survey} />;
};

export default GuidancePageRoute;
